import { RootEntities } from "@eqengage/system-enums"

export const getDefaultClient = () => {
    return window.sessionStorage.getItem("clientCode") ?? RootEntities._Client
}